<template>
    <v-container>
        <div>
            <v-row justify="space-between">
                <v-col cols="12" sm="6" justify="center">
                    <p class="header-title"> {{$t('menu.approve_staff')}} </p>
                </v-col>

                <v-col cols="12" sm="6" justify="center">
                    <div class="d-flex flex-row-reverse">
                        <v-btn color="primary" dark @click="getData">{{ $t('common.refresh')}}</v-btn>
                    </div>
                </v-col>
            </v-row>
        </div>

        <v-data-table :headers="headers" :items="desserts" :search="search" :loading="loading" class="elevation-1" hide-default-footer :page.sync="page" :items-per-page="itemsPerPage" @page-count="pageCount = $event">
            <template v-slot:top>

                <!-- <v-container align="center"> -->
                <v-toolbar flat color="white" class="pt-5"> 
                    <v-row justify="start">
                        <v-col cols="12" sm="1">
                            <v-autocomplete v-model="itemsPerPage" :items="numberPage" outlined dense></v-autocomplete>
                        </v-col>

                        <v-col cols="12" sm="2" v-if="isAdmin || userCategory > 2">
                            <v-autocomplete v-model="selectCategoryFilter" :items="categoriesFilter" item-text="title" v-bind:label="$t('job_management.role')" return-object outlined dense></v-autocomplete>
                        </v-col>
                        
                        <v-col cols="12" sm="2" v-if="isAdmin">
                            <v-autocomplete v-model="selectBlock" :items="blocks" item-text="name" v-bind:label="$t('department_management.block')" return-object outlined dense></v-autocomplete>
                        </v-col>

                        <v-col cols="12" sm="7">
                            <v-text-field v-model="search" append-icon="search" v-bind:label="$t('common.search')" single-line hide-details outlined dense></v-text-field>
                        </v-col>
                    </v-row>
                </v-toolbar>
                <!-- </v-container> -->
            </template>

            <template v-slot:[`item.nickname`]="{ item }">
              <div class="contentAddress">
                <v-avatar size="30" class="mr-1">
                  <img v-if="item.avatar" :src="baseImage + item.avatar"/>
                  <img v-else src='@/assets/avatar_default.png'/>
                </v-avatar>

                <span class="text-no-wrap"> {{ item.nickname }} </span>
              </div>

            </template>

            <template v-slot:[`item.action`]="{ item }">
                <v-btn color="primary" @click="approve(item)">
                    <!-- <span class="linkText text-no-wrap"> </span> -->
                    {{ $t('staff_management.approve') }} 
                </v-btn>
            </template>

            <template v-slot:[`item.fullname`]="{ item }">
                <span class="text-no-wrap">
                  {{ item.fullname }}
                </span>
            </template>

            <template v-slot:[`item.identify`]="{ item }">
                <span class="text-no-wrap">
                  {{ item.identify }}
                </span>
            </template>


            <template v-slot:[`item.email`]="{ item }">
                <span class="contentTitle">
                  {{ item.email }}
                </span>
            </template>

            <template v-slot:[`item.status`]="{ item }">
                <span class="text-no-wrap">
                  {{ getStringByStatus(item.status) }}
                </span>

                <!-- <v-switch :true-value="1" :false-value="0" v-model="item.status" color="primary" v-else>
                </v-switch>  -->
            </template>

            <template v-slot:[`item.joined_date`]="{ item }">
                <span class="text-no-wrap">{{item.joined_date | formateDate}}</span>
            </template>

            <template v-slot:[`item.birthday`]="{ item }">
                <span class="text-no-wrap">{{item.birthday | formateDate}}</span>
            </template>

            <template v-slot:[`item.address`]="{ item }">
                <span class="contentAddress">{{addressToString(item.address)}}</span>
            </template>

            <template v-slot:[`item.job`]="{ item }">
                <span class="contentAddress">{{getJobDisplay(item.job)}}</span>
            </template>

            <template v-slot:[`item.detail`]="{ item }">
                <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                    <template v-slot:activator="{ on }">
                        <v-icon v-on="on" small class="mr-2" @click="showDialogUserInfor(item)">
                        info
                        </v-icon>
                    </template>
                    <span>Thông tin chi tiết</span>
                </v-tooltip> 
            </template>

            <template v-slot:no-data>
                <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
            </template>
        </v-data-table>

        <div class="text-center pt-2">
          <v-pagination v-model="page" :length="pageCount"></v-pagination>
        </div>

        <user-infor-dialog v-model="dialogUserInfor" :editedItem="editedItem" @closeDialog="closeDialogUserInfor"
          v-if="editedItem"> 
        </user-infor-dialog>
    </v-container>
</template>

<script>
import i18n from '@/plugins/i18n';
import UserInforDialog from "@/components/UserInforDialog";

export default {
    data: () => ({
        e1 : 0,
        page: 1,
        pageCount: 0,
        itemsPerPage: 10,

        isAdmin: localStorage.getItem('isAdmin') === 'true' ? true : false,
        userCategory: parseInt(localStorage.getItem('category')),

        baseImage: process.env.VUE_APP_BASE_IMAGE,
        baseAttach: process.env.VUE_APP_BASE_ATTACH,

        blocks: [],
        selectBlock: null,
        
        firstEdit: true,
        search: '',
        dialog: false,

        loading: true,
        numberPage: [
            5, 10, 15, 20, 25
        ],


        headers: [
            { text: '#', align: 'left', sortable: false, value: 'index' },
            { text: i18n.t('profile.nickname'), value: 'nickname', sortable: false},
            { text: i18n.t('profile.fullname'), value: 'fullname', sortable: false},
            { text: i18n.t('profile.email'), value: 'email', sortable: false},
            { text: i18n.t('profile.phone'), value: 'phone', sortable: false },
            { text: i18n.t('job_management.role'), value: 'job', sortable: false },
            // { text: i18n.t('profile.birthday'), value: 'birthday', sortable: false},
            // { text: i18n.t('profile.identify'), value: 'identify', sortable: false},
            // { text: i18n.t('profile.address'), value: 'address', sortable: false},
            { text: i18n.t('profile.join_date'), value: 'joined_date', sortable: false},
            // { text: i18n.t('profile.status'), value: 'status', sortable: false},
            { text: i18n.t('design_manager.infor'), align: 'center', value: 'detail', sortable: false },
            { text: '', value: 'action', sortable: false}
        ],
        jobToAdd: [],
        jobs: [],
        desserts: [],
        fullStaff: [],
        editedIndex: -1,
        editedItem: null,
        defaultItem: {},

        categoriesFilter: [],
        selectCategoryFilter: null,

        dialogUserInfor: false,
    }),

    computed: {
    },

    components: {
        UserInforDialog: UserInforDialog
    },


    watch: {
        selectCategoryFilter() {
            this.filterData();
        },

        selectBlock() {
            this.filterData();
        }
    },

    async created() {
        await this.getBlock();
    },

    async mounted() {
      await this.getData();
      await this.getAllCategory();
    },

    methods: {
        initialize() {
        },

        closeDialogUserInfor(value) {
            this.dialogUserInfor = value
            this.editedItem = null;
        },

        showDialogUserInfor(item) {
            this.editedItem = Object.assign({}, item);            
            this.dialogUserInfor = true;
        },

        async getData() {
            this.loading = true;
            try {
                const response = await this.$http.get(process.env.VUE_APP_GET_USER_CONTEXT_URL + '?status=2');
                if (response.data && response.data.success) {
                    // console.log(response.data);
                    const contextArr = response.data.data;
                    contextArr.forEach((item, index) => item.index = index + 1);
                    this.fullStaff = contextArr;
                    this.desserts = contextArr;
                    this.loading = false;
                }
            } catch (e) {
                console.log(e.stack);
            }
        },

        addressToString(address) {
            if (address && address.fullDetail) {
                return address.fullDetail;
            } else {
                return '';
            }
        },

        async getAllCategory() {
            try {
                const response =  await this.$http.get('/job/categories/0');
                if(response.data && response.data.success) {
                    this.categories = response.data.data;
                    if (!this.isAdmin) {
                        this.categories = this.categories.filter(item => item.type < this.userCategory);
                    }

                    if (Array.isArray(this.categories) && this.categories.length > 0) {
                        this.selectCategory = this.categories[0];
                    }

                    const optionAll = {
                        title : "Tất cả",
                        _id : "-1"
                    }

                    this.categoriesFilter = [optionAll].concat(this.categories);
                    this.selectCategoryFilter = optionAll;
                }
            } catch(e) {
                console.log(e.stack);
            }
        },

        getJobDisplay(job) {
            if (!job) {
                return '';
            }

            return job.title;
        },

        async getBlock() {
            try {
                const response = await this.$http.get(process.env.VUE_APP_GET_BLOCK_URL);
                if (response.data && response.data.success) {
                    const optionAll = {
                    name : "Tất cả",
                    _id : "-1"
                    }

                    this.blocks = [optionAll].concat(response.data.data);
                    this.selectBlock = optionAll;
                }
            } catch (e) {
                //TODO add alert / flash service to Vue => Like Toast in Android

                //Only print stack trace if development
                console.log(e.stack);
                // dùng vue alert //alert(e.message);
            }
        },

        getStringByStatus(status) {
            if (status == 1) {
                return i18n.t('profile.active')
            } else if (status == 2) {
                return i18n.t('profile.waiting_approve');
            } else {
                return i18n.t('profile.inactive')
            }
        },

        filterData() {
            if (!this.fullStaff || this.fullStaff.length == 0) {
                return;
            }

            this.desserts = [].concat(this.fullStaff);
            let dataArray = [];

            if (this.selectCategoryFilter && this.selectCategoryFilter._id != -1) {
                this.fullStaff.forEach(item => {
                    const staff = item.jobs.find(job => job.category && job.category._id == this.selectCategoryFilter._id);

                    if (staff) {
                        dataArray.push(item);
                    }
                })

                this.desserts = [].concat(dataArray);
            }
            
            let tempDataArray = [];
            if (this.selectBlock && this.selectBlock._id != -1) {
                this.desserts.forEach(item => {
                    if (item.jobs && item.jobs.length > 0) {
                        item.jobs.forEach(job => {
                            if (job.context) {
                                if (job.context.parents && job.context.parents.length > 0) {
                                    const context = job.context.parents.find(parent => parent._id == this.selectBlock._id);
                                    if (context) {
                                        tempDataArray.push(item);
                                    }
                                } else {
                                    if (job.context._id == this.selectBlock._id) {
                                        tempDataArray.push(item);
                                    }
                                }
                            }
                        });
                    }
                })

                this.desserts = [].concat(tempDataArray);
            }
        },

        async approve(item) {
            const agree = confirm(i18n.t('common.confirm_approve_staff'))
            if (agree) {
                const self = this;
                try {
                    const response = await this.$http.post(process.env.VUE_APP_APPROVE_USER_API + item._id);

                    if (response.data && response.data.success) {
                        this.$fire({
                            title: i18n.t('common.update_success'),
                            text: "",
                            type: "success"
                            }).then(() => {
                                self.getData();
                        });
                    }
                } catch (e) {
                    console.log(e.stack);
                }
            }
        }
    },
}
</script>

<style scoped>

  .v-text-field .v-input__control .v-input__slot {
    min-height: 45px !important;
    /* display: flex !important; */
    align-items: center !important;
  }
</style>
